export enum ChangeRequestStatus {
  Open = 1,
  Accepted = 2,
  Rejected = 3,
  Closed = 4,
}

export const CHANGE_REQUEST_STATUS_LABELS: any = {
  [ChangeRequestStatus.Open]: 'open',
  [ChangeRequestStatus.Accepted]: 'accepted',
  [ChangeRequestStatus.Rejected]: 'rejected',
  [ChangeRequestStatus.Closed]: 'closed',
};
